(function(){
  function init(){
    document.querySelectorAll('.rad-arrivals .rad-frame').forEach(function(f){
      var img=f.querySelector('.rad-frame__photo img'); if(!img) return;
      var orig=img.getAttribute('src');
      f.querySelectorAll('.rad-sw[data-image]').forEach(function(s){
        s.addEventListener('mouseenter',function(){
          img.src=s.dataset.image; img.removeAttribute('srcset');
          f.querySelectorAll('.rad-sw').forEach(function(o){o.classList.remove('is-on')}); s.classList.add('is-on');
        });
      });
      f.addEventListener('mouseleave',function(){
        img.src=orig; f.querySelectorAll('.rad-sw').forEach(function(o){o.classList.remove('is-on')});
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();